import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/share/courseware/$token/")({
  head: () => ({ meta: [{ title: "课件分享 · imiker" }] }),
});
